export const Passwordpattern=/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,16}$/
export const Emailpattern=/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
export const Namepattern=/^[a-zA-Z][a-zA-Z][a-zA-Z ]{0,18}$/i
export const Mobilepattern=/^[5-9]\d{7,15}$/
export const IfscCodepattern=/^[A-Z]{4}0[A-Z0-9]{6}$/
export const upiRegexpattern = /^[\w.-]+@[\w.-]+$/
export const usernamePattern=/^[a-zA-Z0-9._-]+$/
export const urlRegexpatter=/https?:\/\/(www\.)?[a-zA-Z0-9-._~:/?#@!$&'()*+,;=%]+\.[a-zA-Z]{2,}([a-zA-Z0-9-._~:/?#@!$&'()*+,;=%]*)?/

export const passwordArray = [
    "A1pple",
    "A1pple@Time",
    "B3acon#Day",
    "C0ffee",
    "C0ffee!Mug",
    "Mug",
    "D@tabase42",
    "EasY",
    "EasY#1234",
    "F1sh@Tank",
    "G@laxy999",
    "H0use#Key",
    "Ic3@Cream",
    "Jungle",
    "Jungle@34",
    "K@ngaroo17",
    "L0cket#Box",
    "M@rvel123",
    "Night@W1nd",
    "Op3n#Door",
    "P@ss12345",
    "Qu1ck@Fix",
    "R@inb0w66",
    "S@f3house9",
    "T1ger!Step",
    "Under#4rm",
    "V1rus@2025",
    "W1ndow!Log",
    "Xpl0re@Web",
    "Y@chtD3ck",
    "Zebra@88",
    "MyP@ssW0rd",
    "Secure#Day",
    "Log!nT1me",
    "T@styP@sta",
    "G0al!Keep",
    "Bright@Sky",
    "Lucky",
    "Lucky#Coin",
    "Dream",
    "Dream@Big1",
    "Echo@Base9",
    "Base",
    "Zoom",
    "Zoom#Fast2",
    "Fast",
    "Now@W0rk!",
    "Now",
    "Sharp#View",
    "Plan3t@X9",
    "K1te!Jump",
    "Quiz",
    "Quiz#Show5",
    "W!nner123",
    "Un1que@Me",
    "Track@Run",
    "Vote@Safe7",
    "Node@Home1",
    "Byte!Code2",
    "Fly!Away90",
    "Clever",
    "Clever@10",
    "Push",
    "Push@Up77",
    "Core@Tech9",
    "Bright!Net",
    "Mix@Data22",
    "Build#Now7",
    "Read3r@01",
    "Shell",
    "Run",
    "Shell#Run3",
    "Zip",
    "Zip@Safe9",
    "Safe",
    "Jump",
    "Jump3r@Go",
    "Password",
    "Fast",
    "Fast@",
    "P@ssword123",
    "Admin!2024",
    "Welc0me@Home",
    "Home",
    "S3cur3!Me",
    "L0gin",
    "L0gin#Now",
    "Now",
    "Myp@ssW0rd",
    "Acc3ss!Point",
    "User",
    "User@2025",
    "W0rker#One",
    "H0me@Base1",
    "Qwerty",
    "Qwerty#789",
    "C@tchM3IfUCan",
    "Sh@dow123",
    "N3tw0rk!Time",
    "T3st#Case9",
    "G@teWay2025",
    "R3boot#Now",
    "P@nelAccess1",
    "V1rus#Free",
    "L@ptop1234",
    "Syst3m!On",
    "Off1c3@Work",
    "J@vaScrip7!",
    "DeskTop#One",
    "M0use",
    "M0use@Pad",
    "Pad",
    "W1nd0w#Open",
    "Open",
    "Br0wser!Run",
    "C0ntr0l@X",
    "D3bug#Line",
    "Pr0cess!Go",
    "Temp",
    "Temp@123",
    "Test",
    "Test@1234",
    "apple",
    "coffee",
    "mug",
    "database",
    "easy",
    "fish",
    "galaxy",
    "house",
    "cream",
    "jungle",
    "kangaroo",
    "box",
    "marvel",
    "night",
    "door",
    "pass",
    "rainbow",
    "tiger",
    "virus",
    "window",
    "zoom",
    "dream",
    "base",
    "lucky",
    "echo",
    "quiz",
    "winner",
    "unique",
    "track",
    "vote",
    "node",
    "byte",
    "fly",
    "clever",
    "push",
    "core",
    "bright",
    "mix",
    "build",
    "reader",
    "shell",
    "run",
    "zip",
    "safe",
    "jump",
    "password",
    "admin",
    "welcome",
    "home",
    "login",
    "access",
    "user",
    "worker",
    "qwerty",
    "catch",
    "shadow",
    "network",
    "test",
    "gateway",
    "reboot",
    "panel",
    "free",
    "laptop",
    "system",
    "office",
    "javascript",
    "desktop",
    "mouse",
    "pad",
    "open",
    "browser",
    "control",
    "debug",
    "process",
    "temp",
    "admin",
    "admin",
    "admin.user",
    "admin1",
    "admin_123",
    "admin.root",
    "administrator",
    "administrator_1",
    "sys_admin",
    "system.user",
    "system_root",
    "root",
    "root_user",
    "root.123",
    "ceo",
    "ceo.admin",
    "ceo_01",
    "hr.admin",
    "billing_support",
    "finance_team",
    "support_team",
    "support.user",
    "moderator",
    "mod_01",
    "help_desk",
    "help.desk",
    "owner_1",
    "tech.support",
    "tech_admin",
    "auth",
    "auth_user",
    "auth.admin",
    "login.user",
    "logout_1",
    "register_user",
    "signup_form",
    "access_key",
    "access.token",
    "password_reset",
    "session_user",
    "secure_login",
    "token.auth",
    "key_123",
    "dev.user",
    "dev_team",
    "dev.ops",
    "frontend_admin",
    "backend.user",
    "staging_env",
    "prod.admin",
    "localhost_user",
    "client_server",
    "server.admin",
    "cdn_user",
    "proxy_user",
    "gateway.auth",
    "api.user",
    "api_docs",
    "admin_panel",
    "user.dashboard",
    "settings_user",
    "profile_1",
    "profile.settings",
    "contact_form",
    "help.center",
    "docs.api",
    "blog.user",
  ];